module.exports = __webpack_public_path__ + "img/icon_question.75690bc6.svg";